import React from 'react'

export default function Title({mainTitle}) {
  return (
      <h1>{mainTitle}</h1>
  )
}